import { Directive, ElementRef, inject, NgZone, OnDestroy, OnInit, output } from '@angular/core';

import { LOAD_MORE_DISTANCE } from './infinite-scroll.constants';

@Directive({
  selector: '[empathyInfiniteScroll]'
})
export class InfiniteScrollDirective implements OnInit, OnDestroy {
  loadMore = output<void>();

  private element = inject(ElementRef<HTMLElement>);
  private zone = inject(NgZone);
  private animationFrameId: number = null;

  ngOnInit(): void {
    this.zone.runOutsideAngular(() => this.element.nativeElement.addEventListener('scroll', this.onScroll, { passive: true }));
  }

  ngOnDestroy(): void {
    this.element.nativeElement.removeEventListener('scroll', this.onScroll);
    this.cancelAnimationFrame(this.animationFrameId);
  }

  private onScroll = (): void => {
    if (this.animationFrameId !== null) {
      return;
    }

    this.animationFrameId = this.requestAnimationFrame(() => {
      this.animationFrameId = null;
      this.emitWhenNearBottom();
    });
  };

  private emitWhenNearBottom(): void {
    const element = this.element.nativeElement;
    const distanceToBottom = element.scrollHeight - element.scrollTop - element.clientHeight;

    if (distanceToBottom < LOAD_MORE_DISTANCE) {
      this.zone.run(() => this.loadMore.emit());
    }
  }

  private requestAnimationFrame(callback: FrameRequestCallback): number {
    if (globalThis.requestAnimationFrame) {
      return globalThis.requestAnimationFrame(callback);
    }

    return window.setTimeout(() => callback(Date.now()));
  }

  private cancelAnimationFrame(animationFrameId: number): void {
    if (animationFrameId === null) {
      return;
    }

    if (globalThis.cancelAnimationFrame) {
      globalThis.cancelAnimationFrame(animationFrameId);
      return;
    }

    window.clearTimeout(animationFrameId);
  }
}
